import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";
import API from "../../utils/API";
import { RequestContext } from "../../utils/context/RequestContext";

const InjectAxiosInterceptors = () => {
  const navigate = useNavigate();

  const { setRequestLoading } = useContext(RequestContext);

  useEffect(() => {
    API.setupInterceptors(navigate, setRequestLoading);
  }, [navigate, setRequestLoading]);

  return null;
};

export default InjectAxiosInterceptors;
